<template>
  <div class="limiter">
    <div id="cover-spin" v-if="loading"></div>
    <div class="container-login100">
      <div class="wrap-login100">
        <form class="login100-form validate-form" onsubmit="return false;">
          <span class="login100-form-logo">
            <img
              src="../assets/images/logo2.png"
              loading="lazy"
              style="border-radius: 50%;height:150px;"
            />
          </span>
          <span class="login100-form-title p-b-34 p-t-27">
            Log in
          </span>
          <div
            class="wrap-input100 validate-input"
            data-validate="Enter username"
          >
            <input
              class="input100"
              type="text"
              name="username"
              placeholder="Username"
              v-model="username"
            />
            <span class="focus-input100" data-placeholder=""></span>
          </div>

          <div
            class="wrap-input100 validate-input"
            data-validate="Enter password"
          >
            <input
              class="input100"
              type="password"
              name="pass"
              placeholder="Password"
              v-model="password"
            />
            <span class="focus-input100" data-placeholder=""></span>
          </div>
          <div
            align="center"
            style="margin-bottom:16px;color:red;font-size:14px;"
            v-if="error"
          >
            {{this.message}}
          </div>
          <div class="container-login100-form-btn">
            <button class="login100-form-btn" @click="login()">
              Login
            </button>
          </div>

          <div class="text-center p-t-90" @click="confirmForgotPassword()">
            Forgot Password?
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/fonts/font-awesome-4.7.0/css/font-awesome.min.css";
import "../assets/fonts/iconic/css/material-design-iconic-font.min.css";
import "../assets/css/main.css";
import "../assets/css/util.css";
import firebase from "firebase/app";
import "firebase/database";
import router from "./../router";
import liffService from "@/services/liff";
const axios = require("axios").default;
//import moment from "moment-timezone";
// @ is an alias to /src
export default {
  name: "PlayLogin",
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  data() {
    return {
      username: "",
      password: "",
      loading: true,
      userId: "",
      error: false,
      message: "Invalid user name or password!",
    };
  },
  methods: {
    async confirmForgotPassword() {
      if (confirm("ลืม password ใช่หรือป่าวคะ")) {
        await window.liff.sendMessages([
          {
            type: "text",
            text: "ลืม Password จ้า พลอยใสจัดการให้หน่อย😍😍"
          }
        ]);
        window.liff.closeWindow();
      }
    },
    login() {
      this.loading = true;
      this.error = false;
      axios({
        method: "post",
        url: "https://ufaeasy.apifast.xyz/login",
        data: {
          username: this.username.trim(),
          password: this.password.trim()
        }
      })
        .then(async response => {
          if (response.data.status && response.data.url) {
            //console.log(window.liff.isInClient());
            this.error = false;
            this.message = '';
            if(window.liff.isInClient()){
              window.liff.openWindow({
                url: response.data.url,
                external: true
              });
              this.loading = false;
              window.liff.closeWindow();
            }else{
              this.loading = false;
              window.liff.openWindow({
                url: response.data.url,
                external: true
              });
              //window.location = response.data.url;
              //window.liff.closeWindow();
            }
          } else {
            if(response.data.message){
              this.message = response.data.message;
            }
            this.loading = false;
            this.error = true;
          }
        })
        .catch(error => {
          // ต้องเป็น arrow function ไม่งั้น this ไม่ใช่ component
          // ของเดิมใช้ function ธรรมดา ทำให้ throw แล้วปุ่มหมุนค้างตลอด
          console.log("login error:", error && error.message);
          this.loading = false;
          this.error = true;
          this.message = "เชื่อมต่อระบบไม่ได้ กรุณาลองใหม่อีกครั้ง";
        });
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (this.userId) {
        const users = (
          await firebase
            .database()
            .ref(`/users`)
            .orderByChild("userId")
            .equalTo(this.userId)
            .once("value")
        ).val();
        if (!users) {
          router.replace("/register");
        } else {
          let user = {};
          let key = '';
          for (const x in users) {
            user = users[x];
            key = x;
          }
          firebase
            .database()
            .ref(`/users/${key}`)
            .update({
              pictureUrl: profile.pictureUrl,
              linename: profile.displayName
            });
          axios({
            method: "post",
            url: "https://ufaeasy.apifast.xyz/login",
            data: {
              username: user.code,
              password: user.password
            }
          })
            .then(async response => {
              if (response.data.status && response.data.url) {
                window.liff.openWindow({
                  url: response.data.url,
                  external: true
                });
                this.loading = false;
                window.liff.closeWindow();
              } else {
                this.loading = false;
              }
            })
            .catch(error => {
              console.log("auto login error:", error && error.message);
              this.loading = false;
            });
        }
      }
    },
    async getFriendship() {
      const friend = await window.liff.getFriendship();
      //document.getElementById('friendship').append(friend.friendFlag);
      if (!friend.friendFlag) {
        if (confirm("โปรด add @ufaeasy888v1 เป็นเพื่อน จะเพิ่มเลยไหม")) {
          window.location = "https://lin.ee/9MgANfz";
        }
      }
    }
  }
};
</script>
<style scoped>
#cover-spin {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0);
  z-index: 9999;
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#cover-spin::after {
  content: "";
  display: block;
  position: absolute;
  left: 48%;
  top: 40%;
  width: 40px;
  height: 40px;
  border-style: solid;
  border-color: black;
  border-top-color: transparent;
  border-width: 4px;
  border-radius: 50%;
  -webkit-animation: spin 0.8s linear infinite;
  animation: spin 0.8s linear infinite;
}
</style>
